import { render } from "./BorderTitleSelect.vue?vue&type=template&id=0bed6d48&scoped=true"
import script from "./BorderTitleSelect.vue?vue&type=script&lang=js"
export * from "./BorderTitleSelect.vue?vue&type=script&lang=js"

import "./BorderTitleSelect.vue?vue&type=style&index=0&id=0bed6d48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0bed6d48"

export default script